/**
 * @generated SignedSource<<21086b8b71278e1907af3104746723fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type featureTogglesScreen_Query$variables = {};
export type featureTogglesScreen_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"featureTogglesScreen_QueryFragment">;
};
export type featureTogglesScreen_Query = {
  response: featureTogglesScreen_Query$data;
  variables: featureTogglesScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "featureTogglesScreen_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "featureTogglesScreen_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "featureTogglesScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureToggleAdminSchema",
            "kind": "LinkedField",
            "name": "FeatureToggle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeatureTogglesConnection",
                "kind": "LinkedField",
                "name": "featureToggles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeatureTogglesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeatureToggle",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "kind",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "TimeBasedLicensesFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "SplitCourseCertificationFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "AbandonedCartReminderFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "ExperimentalModeFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "CourseRecommendationsFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "ScheduledGlobalDiscountFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "SecciDownloadCheckoutFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "SignupMarketingOptInFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "InProductExpressCheckoutFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "ProfileEnrichmentSetNameFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "StoryblokCampaignsFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "PaymentProviderInvoiceNoticeFeatureToggleData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v1/*: any*/),
                                "type": "NoConsentOrderAttributionFeatureToggleData",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "connection",
                "key": "featureTogglesScreen_QueryFragment__featureToggles",
                "kind": "LinkedHandle",
                "name": "featureToggles"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5a4cfed1e876e6335b3aa7ecc8fa38d",
    "id": null,
    "metadata": {},
    "name": "featureTogglesScreen_Query",
    "operationKind": "query",
    "text": "query featureTogglesScreen_Query {\n  ...featureTogglesScreen_QueryFragment\n}\n\nfragment featureTogglesScreen_FeatureToggleFragment on FeatureToggle {\n  id\n  data {\n    __typename\n    kind\n    ... on TimeBasedLicensesFeatureToggleData {\n      name\n      isActive\n    }\n    ... on SplitCourseCertificationFeatureToggleData {\n      name\n      isActive\n    }\n    ... on AbandonedCartReminderFeatureToggleData {\n      name\n      isActive\n      kind\n    }\n    ... on ExperimentalModeFeatureToggleData {\n      name\n      isActive\n    }\n    ... on CourseRecommendationsFeatureToggleData {\n      name\n      isActive\n    }\n    ... on ScheduledGlobalDiscountFeatureToggleData {\n      name\n      isActive\n    }\n    ... on SecciDownloadCheckoutFeatureToggleData {\n      name\n      isActive\n    }\n    ... on SignupMarketingOptInFeatureToggleData {\n      name\n      isActive\n    }\n    ... on InProductExpressCheckoutFeatureToggleData {\n      name\n      isActive\n    }\n    ... on ProfileEnrichmentSetNameFeatureToggleData {\n      name\n      isActive\n    }\n    ... on StoryblokCampaignsFeatureToggleData {\n      name\n      isActive\n    }\n    ... on PaymentProviderInvoiceNoticeFeatureToggleData {\n      name\n      isActive\n    }\n    ... on NoConsentOrderAttributionFeatureToggleData {\n      name\n      isActive\n    }\n  }\n  __typename\n}\n\nfragment featureTogglesScreen_QueryFragment on Query {\n  Admin {\n    FeatureToggle {\n      featureToggles {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            ...featureTogglesScreen_FeatureToggleFragment\n            id\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cda3f4e85b4588d723e00137d83d1b79";

export default node;
